var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    [
      _vm.isAuthed
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "sidebar hf-scrollbar-dark",
              attrs: { dark: "", app: "", fixed: "", clipped: "" },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _c(
                "v-list",
                { staticClass: "px-1 tile-spacing" },
                [
                  _c(
                    "div",
                    { attrs: { id: "step7" } },
                    [
                      _c(
                        "v-list-tile",
                        {
                          attrs: {
                            to: { name: "home" },
                            ripple: "",
                            exact: "",
                            "active-class": "activeLink",
                          },
                        },
                        [
                          _c(
                            "v-list-tile-action",
                            [_c("v-icon", [_vm._v("home")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-tile-content", [
                            _vm._v(_vm._s(_vm.$t("App.Home"))),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasSampleData
                        ? _c(
                            "v-list-tile",
                            {
                              attrs: {
                                ripple: "",
                                to: { name: "allimports" },
                                "active-class": "activeLink",
                              },
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("event_note")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(_vm.$t("App.Imports"))),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasSampleData
                        ? _c(
                            "v-list-tile",
                            {
                              attrs: {
                                ripple: "",
                                to: { name: "guidelines" },
                                "active-class": "activeLink",
                              },
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("rule")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(_vm.$t("App.Guidelines"))),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasSampleData ? _c("Reports") : _vm._e(),
                      _vm._v(" "),
                      _vm.hasSampleData
                        ? _c(
                            "v-list-tile",
                            {
                              attrs: {
                                ripple: "",
                                to: { name: "datasets" },
                                "active-class": "activeLink",
                              },
                            },
                            [
                              _c(
                                "v-list-tile-action",
                                [_c("v-icon", [_vm._v("perm_media")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-tile-title", [
                                _vm._v(_vm._s(_vm.$t("App.Files"))),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("TenantManagement"),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("StationSideMenu", { attrs: { id: "step6" } }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-toolbar",
        {
          attrs: {
            color: _vm.$store.state.currentColor,
            fixed: "",
            "clipped-left": "",
            dark: "",
            app: "",
            id: "main-toolbar",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "8px 0" }, attrs: { id: "step2" } },
            [
              _c("v-toolbar-side-icon", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isAuthed,
                    expression: "isAuthed",
                  },
                ],
                staticClass: "box-shadow",
                attrs: { color: "navbar" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.drawer = !_vm.drawer
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.$vuetify.breakpoint.xsOnly || !_vm.showSearching
            ? _c(
                "v-toolbar-title",
                { staticClass: "ml-0 pl-3", staticStyle: { width: "200px" } },
                [
                  _c(
                    "router-link",
                    { staticClass: "title", attrs: { to: "/" } },
                    [
                      _c("img", {
                        staticStyle: { "margin-bottom": "-7px" },
                        attrs: {
                          src: "/static/images/logo.svg",
                          width: "160px",
                        },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _vm.isAuthed
            ? _c("JumpToStationSearch", {
                on: {
                  showSearching: function ($event) {
                    _vm.showSearching = $event
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.$vuetify.breakpoint.xsOnly ? _c("v-spacer") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { padding: "8px 0" }, attrs: { id: "step4" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 white--text",
                  attrs: { color: "#529844", fab: "", small: "" },
                  on: { click: _vm.openHelp },
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [
                    _vm._v("\n           mdi-book-open\n         "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isAuthed && _vm.isSystemAdmin
            ? _c(
                "div",
                { staticStyle: { padding: "8px 0" }, attrs: { id: "step4" } },
                [
                  _vm.isAuthed && _vm.isSystemAdmin
                    ? _c("AdministrationEntrance")
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isAuthed
            ? _c(
                "div",
                { staticStyle: { padding: "8px 0" }, attrs: { id: "step5" } },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: { "offset-y": "", left: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "box-shadow",
                                      attrs: { round: "", color: "navbar" },
                                    },
                                    on
                                  ),
                                  [
                                    _c("v-icon", { staticClass: "mr-1" }, [
                                      _vm._v("person"),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-none" }, [
                                      _vm._v(
                                        _vm._s(_vm.username) +
                                          " [ " +
                                          _vm._s(_vm.currentUserGroup.name) +
                                          " ]"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1703814123
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { attrs: { dense: "", dark: "" } },
                        [
                          _vm.hasOffice365Authorized
                            ? _c(
                                "v-list-tile",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToSwitchTenant()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-tile-avatar",
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-swap-horizontal"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          _vm._s(_vm.$t("App.SwitchTenant"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasOffice365Authorized
                            ? _c("v-divider")
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goToMessageCenter()
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("mdi-message")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v("Message Center"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goToUserProfile()
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("person")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(_vm.$t("App.UserProfile"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.logOut({ redirect: true })
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [_c("v-icon", [_vm._v("logout")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(_vm.$t("App.Logout"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-content",
        {
          style: {
            height: _vm.fullScreen ? "100vh" : "",
            overflow: _vm.fullScreen ? "hidden" : "",
          },
        },
        [
          _c(
            "v-container",
            { staticStyle: { height: "100%" }, attrs: { fluid: "" } },
            [
              _c("router-view", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isApplicationLoaded || !_vm.isAuthed,
                    expression: "isApplicationLoaded || !isAuthed",
                  },
                ],
                key: _vm.$route.fullPath,
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hideFooter
            ? _c(
                "v-footer",
                { attrs: { height: "100" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { "justify-center": "", "align-center": "" } },
                    [
                      _c(
                        "v-flex",
                        {
                          style: { "margin-top": "12px" },
                          attrs: { xs12: "", "text-xs-center": "" },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "text-xs-center",
                              attrs: { href: "https://www.hatfieldgroup.com/" },
                            },
                            [
                              _c("img", {
                                staticClass: "logo",
                                attrs: {
                                  src: "/static/images/Hatfield-HLogo.svg",
                                  width: "243px",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "text-xs-left": "" } },
                        [
                          _vm._v(
                            "             \n        " +
                              _vm._s(new Date().getFullYear()) +
                              " — "
                          ),
                          _c("strong", [_vm._v("Envirodata")]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("LoadingScreen"),
      _vm._v(" "),
      _vm.btnFlag
        ? _c(
            "v-btn",
            {
              staticClass: "top",
              attrs: { fab: "", dark: "", small: "", color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.backTop()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("App.Top")))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.snackbar.text
        ? _c(
            "v-snackbar",
            {
              staticClass: "mt-3 main-snackbar",
              attrs: {
                top: "",
                color: _vm.snackbar.color,
                timeout:
                  _vm.snackbar.timeout !== null
                    ? _vm.snackbar.timeout
                    : _vm.snackbarSettings.timeout,
                "auto-height": "",
              },
              model: {
                value: _vm.snackbarSettings.show,
                callback: function ($$v) {
                  _vm.$set(_vm.snackbarSettings, "show", $$v)
                },
                expression: "snackbarSettings.show",
              },
            },
            [
              _vm.snackbar.icon
                ? _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v(_vm._s(_vm.snackbar.icon))]
                  )
                : _vm._e(),
              _vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n    "),
              _c(
                "v-btn",
                {
                  attrs: { flat: "" },
                  on: {
                    click: function ($event) {
                      _vm.snackbarSettings.show = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthed ? _c("StackMessages") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }